import { render, staticRenderFns } from "./GeneralInfoDescription.vue?vue&type=template&id=02037ce4"
import script from "./GeneralInfoDescription.vue?vue&type=script&lang=js"
export * from "./GeneralInfoDescription.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoDescription.vue?vue&type=style&index=0&id=02037ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports